import { AntTag, Icons, defaultTheme } from '@agro-club/agroclub-shared'
import { isDealOpen } from 'modules/domain/deal/utils'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { generatePath } from 'react-router-dom'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { Card } from 'views/components/Card/Card'
import { TooltipIcon } from 'views/components/TooltipIcons/TooltipIcons'
import { DealCopyText } from 'views/pages/Deal/DealDetail/DealCopyText'
import { DealDetailEditModal } from 'views/pages/Deal/DealDetail/DealEditModals/DealDetailEditModal'
import { DealHistoryModal } from 'views/pages/Deal/DealDetail/DealHistoryModal'
import { TitleWithButtons } from 'views/pages/Deal/DealDetail/styled'
import LogisticRequestsRoutes from 'views/pages/LogisticsKR/LogisticRequests/routes'
import { useDealContext } from '../DealContext'
import { BrokerInfo } from './BrokerInfo'
import { GeneralInfoContent } from './GeneralInfoContent'
import { PublishToCarriersChannelModal } from '../PublishToCarriersChannel/PublishToCarriersForm'
import { isStatusAfter } from '../helpers'
import { DealStatusTypes } from 'modules/domain/deal/types'
import useFormatDate from 'hooks/useFormatDate'
import { DatesBlock } from './DatesBlock'

const DetailTitleWithTag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const DetailButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
const Wrapper = styled.div`
  @media (max-width: ${defaultTheme.queries.mobile}) {
    padding: 16px;
  }
`

const Tittle = styled(Card.Title)`
  @media (max-width: ${defaultTheme.queries.mobile}) {
    text-align: center;
  }
`
export const GeneralInfo: FC = () => {
  const { t } = useTranslation('deal')
  const { deal, samplesInfo, dealRefetch } = useDealContext()

  const [editModalIsOpen, setEditModalIsOpen] = useState(false)
  const [historyModalIsOpen, setHistoryModalIsOpen] = useState(false)
  const [publishToCarriersIsOpen, setPublishToCarriersIsOpen] = useState(false)
  const formateDate = useFormatDate()
  const requestDetailsPath = deal?.logistics_request_id
    ? generatePath(LogisticRequestsRoutes.Details, { id: deal.logistics_request_id })
    : undefined

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })
  let sendToMaxToolTip = t('send_logistics_request')
  if (deal.logistics_request_sent_to_local_bot_date) {
    sendToMaxToolTip =
      sendToMaxToolTip + `. ${t('prevSentDate')}  ${formateDate(deal.logistics_request_sent_to_local_bot_date)}`
  }
  const showSentToMax = isStatusAfter(deal.status, DealStatusTypes.AGREED)
  return (
    <Wrapper>
      <Card.GapableContent style={{ height: '100%' }}>
        <>
          <TitleWithButtons>
            <DetailTitleWithTag>
              {!isMobile && <Tittle>{t('dealDetail')}</Tittle>}
              <AntTag color={'white'}>{t(`dealTypes.${deal.deal_type}`)}</AntTag>
            </DetailTitleWithTag>
            {isDealOpen(deal) && (
              <DetailButtonsWrapper>
                <TooltipIcon isVisible={!!requestDetailsPath} text={t('logisticRequests')}>
                  <AButton
                    color="secondary"
                    background="none"
                    Icon={Icons.IconShipping}
                    to={requestDetailsPath}
                    id="logistics"
                  />
                </TooltipIcon>

                <TooltipIcon isVisible={!!deal.deal_signed_data} text={t('history')}>
                  <AButton
                    size="medium"
                    color="secondary"
                    background="none"
                    Icon={Icons.IconHistory}
                    onClick={() => setHistoryModalIsOpen(true)}
                    id="history"
                  />
                </TooltipIcon>

                <TooltipIcon isVisible text={t('editDeal')}>
                  <AButton
                    id="edit"
                    size="medium"
                    color="secondary"
                    background="none"
                    Icon={Icons.IconEdit}
                    onClick={() => setEditModalIsOpen(true)}
                  />
                </TooltipIcon>

                <DealCopyText deal={deal} sample={samplesInfo.data?.[0]} />
                {showSentToMax && deal.logistics_request_id && (
                  <TooltipIcon isVisible text={sendToMaxToolTip}>
                    <AButton
                      id="edit"
                      size="medium"
                      color="secondary"
                      background="none"
                      Icon={deal.logistics_request_sent_to_local_bot_date ? Icons.IconMaxdone : Icons.IconMax}
                      disabled={!deal.logistics_request_id}
                      onClick={() => setPublishToCarriersIsOpen(true)}
                    />
                  </TooltipIcon>
                )}
              </DetailButtonsWrapper>
            )}
          </TitleWithButtons>
          <BrokerInfo />
          {isMobile && <Tittle>{t('dealDetail')}</Tittle>}
        </>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
          <GeneralInfoContent />
          <DatesBlock />
        </div>
      </Card.GapableContent>
      {editModalIsOpen && (
        <DealDetailEditModal deal={deal} onClose={() => setEditModalIsOpen(false)} refetch={dealRefetch} />
      )}
      {historyModalIsOpen && <DealHistoryModal deal={deal} close={() => setHistoryModalIsOpen(false)} />}
      {publishToCarriersIsOpen && (
        <PublishToCarriersChannelModal
          onClose={() => setPublishToCarriersIsOpen(false)}
          onSuccess={dealRefetch}
          deal={deal}
          sample={samplesInfo.data?.[0]}
        />
      )}
    </Wrapper>
  )
}
